export default {
  buttons: {
    updateNow: 'Update now',
  },
  serviceMaintenance: {
    title: 'We’ve got some\nupdates brewing.',
    message:
      '<div style="text-align: left;"></div><div>On September 18th, we&apos;re performing system maintenance from 12:00am-3:30am MT.</div><ul><li><b>You won&rsquo;t be able to log in to the Varo app or website.</b></li><li>There will be no impact to direct deposits, existing transfers, or scheduled payments.</li><li>Cash deposits and some card and ATM transactions may not be processed.</li><li>Notifications will be delayed.</li></ul><div>Thank you for your patience while we continue to improve the Varo experience.</div>',
  },
  supportedVersions: {
    title: 'Update required',
    message:
      'We’ve made important updates to the app. To continue, please update to the latest version of the Varo app.',
  },
  unsupportedOS: {
    ios: {
      banner: {
        title: 'Phone update required',
        message:
          'We no longer support your current OS version. Update to iOS {{version}} or higher to get the latest Varo features and security updates.',
        actionTitle: 'Update',
      },
      dialog: {
        title: 'Phone update required',
        message:
          'For the latest Varo features and security upgrades, your phone needs to have iOS {{version}} or higher.',
        primaryActionTitle: 'Dismiss',
        secondaryActionTitle: 'Update',
      },
    },
    android: {
      banner: {
        title: 'Phone update required',
        message:
          'We no longer support your current OS version. Update to Android {{version}} or higher to get the latest Varo features and security updates.',
        actionTitle: 'Update',
      },
      dialog: {
        title: 'Phone update required',
        message:
          'For the latest Varo features and security upgrades, your phone needs to have Android {{version}} or higher.',
        primaryActionTitle: 'Update',
        secondaryActionTitle: 'Dismiss',
      },
    },
  },
};
